import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.6rem 1.2rem;
`

export const NewDemandButton = styled.button`
  font-weight: bold;
  display: flex;
  gap: 0.4rem;
  align-items: center;
  height: 2rem;
  font-size: 0.72rem;
  padding: 0 0.9rem;
  color: #fff;
  cursor: pointer;
  background-color: #0090d3;
  border: none;
  border-radius: 2rem;
  white-space: nowrap;
  flex-shrink: 0;
`

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 1.2rem;
`

export const SupplierGroup = styled.div`
  margin-bottom: 1.2rem;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid #ebebeb;
`

export const SupplierHeader = styled.div`
  background-color: #303030;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.7rem 1rem;
  font-size: 0.78rem;
  gap: 1rem;
`

export const SupplierName = styled.div`
  font-weight: 700;
  white-space: nowrap;
`

export const SupplierSummary = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  color: #d4d4d4;
  font-size: 0.72rem;
  flex: 1;

  strong {
    color: #fff;
  }

  .critical {
    color: #ff8a8a;
  }
`

export const SupplierActions = styled.div`
  display: flex;
  gap: 0.5rem;
`

export const SupplierActionButton = styled.button<{ disabled?: boolean }>`
  border: none;
  border-radius: 1.4rem;
  padding: 0.35rem 0.9rem;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  background-color: ${(props) => (props.disabled ? '#5a5a5a' : '#0090d3')};
  color: #fff;
  white-space: nowrap;
`

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.55rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
  font-size: 0.75rem;

  &:hover {
    background-color: #f7f7f7;
  }
`

export const ExpandButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #696969;
  padding: 0;
`

export const EditButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #696969;
  padding: 0;

  &:hover {
    color: #0090d3;
  }
`

export const ItemCode = styled.div`
  color: #696969;
  min-width: 4.5rem;
`

export const ItemName = styled.div`
  flex: 1;
  min-width: 12rem;
  font-weight: 600;
  color: #303030;

  span {
    display: block;
    font-weight: 400;
    color: #969696;
    font-size: 0.68rem;
  }
`

export const ItemType = styled.span`
  font-size: 0.65rem;
  border-radius: 1rem;
  padding: 0.15rem 0.6rem;
  background-color: #e6f4fb;
  color: #0090d3;
  white-space: nowrap;
`

export const NumericCol = styled.div<{ critical?: boolean }>`
  min-width: 6rem;
  text-align: right;
  color: ${(props) => (props.critical ? '#d32f2f' : '#303030')};
  font-weight: ${(props) => (props.critical ? 700 : 400)};
`

export const ConsumersTable = styled.div`
  background-color: #fafafa;
  padding: 0.6rem 1rem 0.6rem 3.4rem;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.7rem;
`

export const ConsumerRow = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0.3rem 0;
  color: #696969;

  span {
    min-width: 8rem;
  }
`

export const Footer = styled.div`
  display: flex;
  gap: 2rem;
  padding: 0.8rem 1.2rem;
  border-top: 1px solid #ebebeb;
  background-color: #fff;
  font-size: 0.75rem;
`

export const FooterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  strong {
    font-size: 1rem;
  }

  span {
    color: #969696;
    font-size: 0.68rem;
  }
`

export const EmptyState = styled.div`
  padding: 3rem;
  text-align: center;
  color: #969696;
  font-size: 0.8rem;
`
